// extracted by mini-css-extract-plugin
export var links = "Images-module--links---f1kj";
export var widgetWrap = "Images-module--widgetWrap--2sViE";